import { CheckCircle2, CheckIcon, Clock } from "lucide-react";
import { Payout } from "../models/payout/Payout";
import { PAYOUT_REVIEW_STATES } from "../resources/enums";
import ApprovePayout from "../views/partners/ApprovePayoutModal";
import MarkAsPaidModal from "../views/partners/MarkAsPaidModal";
import AddSaleToPayoutModal from "../views/partners/shared/payouts/components/AddSaleToPayoutModal";
import PayoutReview from "../views/partners/shared/payouts/components/PayoutReview";
import useModal from "./modalHook";
import CompletePayout from "../views/partners/shared/payouts/components/CompletePayout";
import { useQueryClient } from "@tanstack/react-query";


interface IStatus {
    isPaid: boolean;
    isReviewed: boolean;
    isApproved: boolean;
}
function usePayouts() {
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const PayoutModal = ModalComponent;
    const queryClient = useQueryClient();

    const addSaleToPayout = (payout: Payout, teamId: string, onProceed?: () => void) => {
        if (payout) {
            updateModalStates({
                show: true,
                children: (
                    <AddSaleToPayoutModal payout={payout} teamId={teamId} onClose={closeModal} onProceed={onProceed} />
                ),
                
                classes: '!p-0 r-[5px]',
                size: '3xl',
                title:'Add Sale To Payout'
            });
        }
    };

    const approvePayout = (payout: Payout, onProceed?: () => void) => {
        if (payout) {
            updateModalStates({
                show: true,
                children: (
                    <ApprovePayout
                        payout={payout}
                        onProceed={(data: any) => {
                            closeModal();
                            onProceed?.();
                        }}
                        onCancel={closeModal}
                        title="Approve commission payout"
                        type={PAYOUT_REVIEW_STATES.APPROVE}
                    />
                ),
                title: 'Approve Payout',
                classes: '!p-0 r-[5px]',
                size: 'sm'
            });
        }
    };

    const requestForPayout = (payout: Payout, onProceed?: () => void) => {
        if (payout) {
            updateModalStates({
                show: true,
                children: (
                    <PayoutReview
                        payout={payout}
                        onProceed={() => {
                            closeModal();
                            onProceed?.();
                        }}
                        onCancel={closeModal}
                        title="Request for payout"
                        // titleIcon={<QuestionIcon />}
                        type={PAYOUT_REVIEW_STATES.REQUEST}
                    />
                ),
                
                classes: '!p-0 r-[5px]',
                size: 'sm'
            });
        }
    };

    const markAsPaid = (payout: Payout, onProceed?: () => void) => {
        if (payout) {
            updateModalStates({
                show: true,
                children: (
                    <MarkAsPaidModal
                        payout={payout}
                        onProceed={() => {
                            closeModal();
                            onProceed?.();
                        }}
                        onCancel={closeModal}
                        title="Mark as paid"
                        titleIcon={<CheckIcon />}
                        type={PAYOUT_REVIEW_STATES.PAID}
                    />
                ),
                
                classes: '!p-0 r-[5px]',
                size: 'lg'
            });
        }
    };

    const handleCompletePayout = async (payout?: Payout, onSuccess?: () => void) => {
        if (!payout || payout === null) return;
        updateModalStates({
            show: true,
            size: 'lg',
            children: (
                <CompletePayout
                    onProceed={() => {
                        closeModal();
                        onSuccess?.();
                    }}
                    onClose={closeModal}
                    payout={payout}
                />
            ),
            showCloseButton: true,
            classes: '!p-0 r-[5px]',
            title: 'Record Payout As Paid'
        });
    }

       const StatusBadge = ({isPaid, isReviewed, isApproved}:IStatus) => {
        const getStatusInfo = () =>{    
        if(isPaid && isReviewed && isApproved){
                return { color: 'bg-green-100 text-green-800', icon: CheckCircle2, status: 'COMPLETED' }
            } else {
                return { color: 'bg-yellow-100 text-yellow-800', icon: Clock, status: 'PENDING' };
            }
        }
            const { color, icon: Icon, status } = getStatusInfo();
    
            return (
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full ${color}`}>
                    <Icon className="w-3 h-3 mr-1" />
                    <span className="capitalize">{status}</span>
                </span>
            );
        };

    return {
        PayoutModal,
        addSaleToPayout,
        approvePayout,
        requestForPayout,
        markAsPaid,
        handleCompletePayout,
        StatusBadge
    }
}

export default usePayouts;

